import React, { ReactElement, useEffect } from 'react';

import { Button, Typography } from '@mui/material';

import { onChangeTableRowsPerPage } from '../../../../../../shared/utils/on-change-table-rows-per-page/on-change-table-rows-per-page.util';
import { onTablePageChange } from '../../../../../../shared/utils/on-table-page-change/on-table-page-change.util';
import { useAppDispatch } from '../../../../../../store/hooks';
import NoResults from '../../../../../shared/components/no-results/NoResults';
import SDCTable from '../../../../../shared/components/ui/Table/components/table/SDCTable';
import { getPaginationConfig } from '../../../../../shared/components/ui/Table/utils/get-pagination-config.util';
import { useGetStatisticsTableSelectors } from '../../hooks/use-get-statistics-table-selectors.hook';
import { addPagination } from '../../store/slices/statistics.slice';
import { getStatisticsTotalCount } from '../../thunks/get-statistics-total-count.thunk';
import { getStatistics } from '../../thunks/get-statistics.thunk';
import { statisticsTableColumnDefUtil } from '../../utils/def/statistics-table-column-def.util';

export const StatisticsTable = (): ReactElement => {
  const {
    statistics: tableRows,
    isLoading,
    paginationParams: { pageNumber, totalCount, size, offset },
    appId,
    activeMandantId,
  } = useGetStatisticsTableSelectors();

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      getStatistics({
        appId: parseInt(appId as string, 10),
        pagination: { pageNumber, totalCount, size, offset },
      })
    );
  }, [appId]);

  useEffect(() => {
    if (activeMandantId !== null && appId) {
      dispatch(getStatisticsTotalCount(+appId));
    }
  }, [activeMandantId, appId]);

  return (
    <>
      {tableRows.length > 0 && (
        <SDCTable
          sx={{
            td: {
              wordWrap: 'break-word',
              overflow: 'hidden',
              padding: '25px 4px',
            },
          }}
          ariaLabel="statistics-table"
          bulkActions={false}
          footerElement={
            <Button variant="contained">
              <Typography>Download Report</Typography>
            </Button>
          }
          checkboxSelection={false}
          columns={statisticsTableColumnDefUtil}
          rows={tableRows}
          stickyHeader={true}
          paginationConfig={getPaginationConfig(
            totalCount,
            size,
            pageNumber,
            onTablePageChange(dispatch, size, addPagination),
            onChangeTableRowsPerPage(dispatch, addPagination)
          )}
        />
      )}
      {tableRows?.length === 0 && !isLoading && <NoResults />}
    </>
  );
};
